import { createStore } from "vuex"
import { pageComponents } from "./page_components.js"
import appStore from "./app_store.js";

import { auth } from "./auth.js"
import { applicants } from "./applicants.js"
import { caps_institutions_list } from "./caps_institutions_list.js"
import { caps_mall_activities } from "./caps_mall_activities.js"
import { caps_mall_applications } from "./caps_mall_applications.js"
import { caps_mall_selections } from "./caps_mall_selections.js";
import { caps_programmes_list } from "./caps_programmes_list.js"
import { institution_account_permissions } from "./institution_account_permissions.js"
import { institution_account_roles } from "./institution_account_roles.js"
import { institution_accounts } from "./institution_accounts.js"
import { institution_admissions_uploads } from "./institution_admissions_uploads.js"
import { institution_campuses } from "./institution_campuses.js"
import { institution_programmes } from "./institution_programmes.js"
import { institution_schools } from "./institution_schools.js"
import { payments } from "./payments.js"
import { waec_results } from "./waec_results.js"

const { state, getters, mutations, actions } = appStore;

const store = createStore({
	state,
	getters,
	mutations,
	actions,
	modules: {
		pageComponents,
		auth,
		applicants,
		caps_institutions_list,
		caps_mall_activities,
		caps_mall_applications,
		caps_mall_selections,
		caps_programmes_list,
		institution_account_permissions,
		institution_account_roles,
		institution_accounts,
		institution_admissions_uploads,
		institution_campuses,
		institution_programmes,
		institution_schools,
		payments,
		waec_results
	},
	// enable strict mode (adds overhead!)
	// for dev mode only
	//strict: process.env.DEV
});
export default store;